var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Prop, Emit, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { FileUploadService } from "~/services/file-service/file-upload.service";
import { Dependencies } from '~/core/decorator';
var ViewAttachList = /** @class */ (function (_super) {
    __extends(ViewAttachList, _super);
    function ViewAttachList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileDataSet = [];
        return _this;
    }
    ViewAttachList.prototype.emitClose = function () { };
    ViewAttachList.prototype.onfileIdsChange = function (val) {
        var _this = this;
        this.fileDataSet = [];
        if (val)
            this.fileUploadService.getAllUploadFileByIds(val).subscribe(function (data) { return _this.fileDataSet = data; });
    };
    __decorate([
        Dependencies(FileUploadService)
    ], ViewAttachList.prototype, "fileUploadService", void 0);
    __decorate([
        Prop({
            required: true,
            type: String
        })
    ], ViewAttachList.prototype, "fileIds", void 0);
    __decorate([
        Emit("close")
    ], ViewAttachList.prototype, "emitClose", null);
    __decorate([
        Watch("fileIds", { immediate: true })
    ], ViewAttachList.prototype, "onfileIdsChange", null);
    ViewAttachList = __decorate([
        Component({
            components: {}
        })
    ], ViewAttachList);
    return ViewAttachList;
}(Vue));
export default ViewAttachList;
